<template>
    <div>
        <v-dialog v-model="visible" max-width="800px">
            <v-card>
                <v-card-text class="detail-card-text">
                    <p>本公司/单位确认：</p>
                    <p>本保险合同保费是否由投保人<span class="font-primary">{{ companyName }}</span>企业账户支付？</p>
                    <div class="detail-button">
                        <v-btn icon @click="close">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </div>
                    <v-flex class="form-item form-item-center">
                        <v-radio-group v-model="form.isCompanyPay" row class="form-item-center-radio">
                            <v-radio
                                    v-for="(item, key) in radioMap"
                                    :key="key"
                                    :label="item.label"
                                    :value="item.value"
                                    class="form-item-center-radio-item"
                            />
                        </v-radio-group>
                    </v-flex>
                </v-card-text>
                <v-container class="v-container-form">
                    <v-form
                        ref="form"
                        v-model="valid"
                        lazy-validation
                    >
                        <div :style="form.isCompanyPay == 1 ? 'display:none' : 'display:block'">

                            <v-flex class="form-item form-item-left">
                                <label><span class="must-tap">*</span>付款人姓名</label>
                                <v-text-field v-model="form.payName" :solo="true" :rules="rules.name" />
                            </v-flex>
                            <v-flex class="form-item form-item-left">
                                <label><span class="must-tap">*</span>账号</label>
                                <v-text-field
                                        v-model="form.payAccount"
                                        :solo="true"
                                        :rules="rules.account"
                                        placeholder="请填写银行账户；若使用微信或支付宝余额付款，请填写“微信/支付宝余额付款”"
                                />
                            </v-flex>
                            <v-flex class="form-item form-item-left">
                                <label><span class="must-tap">*</span>代付款原因</label>
                                <v-text-field
                                        v-model="form.payAgentReason"
                                        :solo="true"
                                        :rules="rules.reason"
                                        placeholder="例：公司同意"
                                />
                            </v-flex>
                            <v-flex class="form-item form-item-left">
                                <label style="margin-top: -4px">
                                    <span class="must-tap">*</span>付款人与投保人企业关系</label>
                                <v-text-field
                                        v-model="form.payRelation"
                                        :solo="true"
                                        :rules="rules.payRelation"
                                        placeholder="例：员工"
                                />
                            </v-flex>
                            <p>本人确认已获得上述投保企业授权支付保费、若发生退费，原路返还至交款账户。</p>

                        </div>
                        <div class="v-btn-div">
                            <div><v-btn
                                    color="primary"
                                    :loading="loading"
                                    @click="submitCompany"
                            >确认</v-btn></div>
                        </div>
                    </v-form>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props:{
            value: {
                type: Boolean,
                default: false
            },
            companyName: {
                type: String,
                default: ""
            },
            policyCode: {
                type: String,
                default: ""
            },
            orderCode: {
                type: String,
                default: ""
            },
            policySaveObj:{
                type: Object,
                default: {}
            },
            policyType:{
                type: String,
                default: "policy"
            },
            isContinue:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                form : {
                    isCompanyPay: 0,
                    payName: "",
                    payAccount: "",
                    payAgentReason: "",
                    payRelation: "",
                    policyType: this.policyType
                },
                rules: {
                    name: [v => !!v || "请输入付款人姓名"],
                    account: [v => !!v || "请输入账号"],
                    reason: [v => !!v || "请输入代付款原因"],
                    payRelation: [v => !!v || "请输入付款人与投保企业关系"],
                },
                radioMap:[
                    {label:"是", value: 1},
                    {label:"否", value: 0},
                ],
                accountMessage: "",
                valid: true,
                loading: false
            }
        },
        computed: {
            visible: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit("input", v);
                }
            }
        },
        watch:{
            orderCode: function (val) {
                this.orderCode = val;
                this.getPayCompanyDetailData();
            }
        },
        mounted() {
            if (this.isContinue && this.orderCode) {
                this.getPayCompanyDetailData();
            }
        },
        methods: {
            tipsMessage(v){
                if (v) {
                    this.accountMessage = "请填写银行账户；若使用微信或支付宝余额付款，请填写写“微信/支付宝余额付款"
                }else{
                    this.accountMessage = ""
                }
            },
            getPayCompanyDetailData(){
                this.$axios.get('/app/api/heshunbao/getPayCompanyDetail?orderCode=' + this.orderCode + "&policyType="+this.policyType).then(res => {
                    if (res.data.isCompanyPay == 0) {
                        this.form.orderCode = this.orderCode
                        this.form.isCompanyPay = res.data.isCompanyPay
                        this.form.payAccount = res.data.payAccount
                        this.form.payName = res.data.payName
                        this.form.payRelation = res.data.payRelation
                        this.form.payAgentReason = res.data.payAgentReason
                    }else{
                        this.form.isCompanyPay = 1;
                    }
                })
            },
            close(){
                this.visible = false;
            },
            submitCompany(){
                if (this.form.isCompanyPay == 0) {
                    if (!this.$refs.form.validate()){
                        return false;
                    }
                }
                this.loading = true
                this.form.orderCode = this.orderCode;
                this.$axios.post("/app/api/heshunbao/submitPolicyCompanyPay", this.form).then(result => {
                    this.loading = false;
                    this.$emit("submitCompany", this.policySaveObj);
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .detail-card-text{
        position: relative;
        padding: 30px 30px 0 30px;
        p:nth-child(1){
            width: 80%;
        }
        div.detail-button{
            position: absolute;
            right: 5px;
            height: 50px;
            width: 50px;
            top: 5px;
        }
    }
    .v-container-form {
        padding: 30px;
        p{
            color: #dd122a !important;
            font-size: 13px;
            text-align: center;
        }
    }
    .v-container-form-display{
        display: none;
    }
    .form-item label{
        width: 86px;
        margin-top: 5px;
    }
    .form-item-center{
        position: relative;
        width: 200px;
        .form-item-center-radio{
            position: relative;
            width: 100%;
            margin-top: 0;
            .form-item-center-radio-item{
                width: 70px;
                height: 35px;
                position: absolute;
                margin-top: 0;
            }
            .form-item-center-radio-item:nth-child(2){
                left: 80px;
            }
        }
    }
    .v-btn-div{
        position: relative;
        height: 66px;
        padding: 5px;
        div{
            position: absolute;
            left: 43%;
        }
    }
    .font-primary{
        color: #dd122a !important;
    }
    .must-tap {
        color: red;
        margin-right: 3px;
    }
</style>
